<template>
	<div class="bar">
		<div
			class="bar-content"
			v-html="$root.routeTitle"
			v-if="$root.routeTitle !== ''"
		/>

		<div
			class="bar-offline"
			v-if="$mq.isOffline()"
			v-html="`Non c'è connessione`"
		/>
	</div>
</template>

<script>

import BannerGreeting from '../Parts/BannerGreeting'

export default {
	data () {
		return {
		}
	},

	components: {
		BannerGreeting
	}
}
</script>

<style scoped>
.bar {
	position: fixed;
	top: 0;
	text-align: center;
	width: 100%;
	color: white;
	z-index: 7;
}

.bar-content {
	font-weight: bold;
	background-color: var(--quomi-primary);
	margin: 0 auto;
	padding: 10px 0;
	height: 45px;
}

.bar-offline {
	width: 100%;
	padding: 5px 0;
	background-color: grey;
}

</style>
